export default "__VITE_PUBLIC_ASSET__c139ab61__"